import { render, staticRenderFns } from "./RecentDownloadsHome.vue?vue&type=template&id=f24a642e&scoped=true"
import script from "./RecentDownloadsHome.vue?vue&type=script&lang=js"
export * from "./RecentDownloadsHome.vue?vue&type=script&lang=js"
import style0 from "./RecentDownloadsHome.vue?vue&type=style&index=0&id=f24a642e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24a642e",
  null
  
)

export default component.exports